// Aviso de que uma ASSINATURA foi gravada, para quem guarda leitura derivada dela.
//
// O painel do grupo econômico lê os ramais do rateio (`rateio.base`), que o
// backend calcula a partir das assinaturas e que o front guarda em cache
// (useRateio). Até 05/10/2026, salvar a assinatura não avisava ninguém: o Heitor
// mudou a Pré-Fabricados de 14 para 20 ramais e o painel seguiu com 14 até
// recarregar a página.
//
// O aviso sai do interceptor do axios (services/api.ts), e não de cada tela que
// salva: são pelo menos seis caminhos de escrita em /contracts (App, Faturas,
// Propostas, itens por local…), e qualquer um novo já nasce coberto.

export const ASSINATURA_GRAVADA = 'hub:assinatura-gravada';

const ESCRITA = new Set(['post', 'put', 'patch', 'delete']);

/** Escrita bem-sucedida em /contracts (inclui itens e anexos da assinatura). */
export function gravouAssinatura(metodo?: string, url?: string): boolean {
  if (!metodo || !ESCRITA.has(metodo.toLowerCase())) return false;
  return /^\/?contracts(\/|\?|$)/.test(url || '');
}

export function avisarSeGravouAssinatura(metodo?: string, url?: string): void {
  if (gravouAssinatura(metodo, url) && typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ASSINATURA_GRAVADA));
  }
}
